import { get, isEmpty, reduce } from 'lodash';
import { QuoteResponse } from './types';

export const getQuoteError = (quote: QuoteResponse): boolean => {
  return reduce(
    get(quote, 'paxes', []),
    (res, traveller) => !isEmpty(get(traveller, 'plans.errors', {})) || res,
    false
  );
};
